import GroupParentDisplay from './GroupParentDisplay';
export default GroupParentDisplay;